var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.764 2.25087L23.5724 0.518688V0.140625H17.3013L12.8328 11.2705L7.73691 0.140625H1.15962V0.518688L3.27562 3.06666C3.48263 3.25569 3.589 3.52737 3.55953 3.80553V13.8113C3.62422 14.1721 3.50634 14.5444 3.25191 14.8046L0.875 17.6954V18.0677H7.63125V17.6896L5.24931 14.811C5.12171 14.682 5.02546 14.5254 4.96801 14.3533C4.91056 14.1812 4.89344 13.9982 4.91797 13.8184V5.15894L10.8527 18.0742H11.5441L16.6444 5.1575V15.45C16.6444 15.7224 16.6444 15.7756 16.4668 15.9531L14.634 17.7256V18.1043H23.5372V17.7256L21.7691 15.9934C21.693 15.9361 21.6341 15.859 21.5987 15.7706C21.5633 15.6821 21.5529 15.5857 21.5685 15.4917V2.75903C21.5484 2.66457 21.5561 2.56629 21.5906 2.4761C21.6252 2.38591 21.6859 2.30768 21.764 2.25087Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.fb52022a079201de07377fe13057bdb3.svg";
export { ForwardRef as ReactComponent };